var widget_default = {
  "card": "_3KvB1",
  "link": "DlNU3",
  "container": "pi81z",
  "image": "q7aQh",
  "right": "CJnLx",
  "cardLayout": "_7sn11",
  "content": "AHScA",
  "title": "I8k6a",
  "subtitle": "TG9b8",
  "button": "AfKvr",
  "button_disabled": "p7IDL",
  "buttonText": "FROEG",
  "slimLayout": "EjJqN",
  "contentText": "AA7XZ"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
